import { type z } from "zod";

import { AddressSchema } from "@/.zenstack/zod/models/Address.schema";

/**
 * Error-only schema for Location form (blocking validation)
 *
 * Contains only required field validation from Address.schema (generated from .zmodel).
 * This validation blocks form submission.
 */
export const LocationErrorSchema = AddressSchema;

/**
 * Warning-only schema for Location form (non-blocking recommendations)
 *
 * Contains UX recommendations that don't block submission.
 * These are shown immediately to guide users toward best practices.
 */
export const LocationWarningSchema = AddressSchema.superRefine((data, ctx) => {
  // FORM-LEVEL WARNING: Recommend address verification for map features
  if (!data.verifiedAt) {
    ctx.addIssue({
      code: "custom",
      message: "Accept an auto-completion to map your listing.",
      severity: "warning",
      path: [], // Empty path makes this a form-level warning
    });
  }
}).superRefine((data, ctx) => {
  // FIELD-LEVEL WARNING: Recommend address verification on street field
  if (!data.verifiedAt) {
    ctx.addIssue({
      code: "custom",
      message:
        "Accept the address autocomplete suggestion to enable your listing to appear with a map and in map-based searches",
      severity: "warning",
      path: ["streetLine1"],
    });
  }
});

export type LocationFormData = z.infer<typeof LocationErrorSchema>;
